import './DetailValue.css';

import { useEffect, useRef, useState } from 'react';

export interface DetailValueProps {
  value: string;
}

const DetailValue = ({ value }: DetailValueProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [hasOverflow, setHasOverflow] = useState<boolean>(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const resizeObserver = new ResizeObserver(() => {
      setHasOverflow(el.scrollHeight > el.clientHeight);
    });
    resizeObserver.observe(el);
    return () => resizeObserver.disconnect();
  }, [value]);

  return (
    <span
      ref={ref}
      className="detail-value"
      data-pr-tooltip={hasOverflow ? value : undefined}
    >
      {value || ' '}
    </span>
  );
};

export default DetailValue;
